<template>
  <section v-if="lang.vcc">
    <Title :title-name="lang.vcc.SFS_LANG_ROW_7" :title-link="title.VirtualCreditCardDetail.titleLink" />
    <div class="container" style="margin-top: 14pt">
      <div>
        <p>{{ lang.vcc.SFS_LANG_ROW_2 }}</p>
        <div v-if="clientAccessTokens">
          <div v-for="(client, index) in clientAccessTokens" :key="index">
            <CreditCard :client="client"></CreditCard>
          </div>
        </div>
        <div v-else>
          <CreditCard></CreditCard>
        </div>
        <p>{{ lang.vcc.SFS_LANG_ROW_3 }}</p>
        <p>{{ lang.vcc.SFS_LANG_ROW_4 }}</p>
        <p>{{ lang.vcc.SFS_LANG_ROW_5 }}</p>
        <p
          v-html="
            replaceStr(
              lang.vcc.SFS_LANG_ROW_6,
              ['<amount>', '<currency>'],
              [VirtualCreditCardDetail.price_per_person, newcurrency]
            )
          "
        ></p>
      </div>
    </div>
  </section>
</template>

<script>
import CreditCard from '@/components/CreditCard/index'
import { mapGetters } from 'vuex'
import { replaceStr } from '@/utils/helper'
import Title from '@/components/Title/index'

export default {
  name: 'VirtualCreditCardDetail',
  components: { CreditCard, Title },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      pageTitle: 'Virtual Creditcards',
      newcurrency: '',
      clientAccessTokens: {}
    }
  },
  computed: {
    ...mapGetters({
      VirtualCreditCardDetail: 'VirtualCreditCardDetail/VirtualCreditCardDetail'
    })
  },
  watch: {
    VirtualCreditCardDetail: function (newVal) {
      this.newcurrency = newVal.currency.toUpperCase()
    },
    pax: function () {
      this.getClientAccessTokens()
    }
  },
  created() {
    this.$store.dispatch('VirtualCreditCardDetail/getVirtualCreditCardDetail')
    this.getClientAccessTokens()
  },
  methods: {
    replaceStr,
    getClientAccessTokens() {
      if (!_.isEmpty(this.clientAccessTokens) || _.isEmpty(this.pax)) {
        return
      }

      this.$store
        .dispatch('getClientAccessToken', {
          passenger_id: this.pax.id,
          service_id: this.$route.query.service_id,
          secret: this.secret
        })
        .then((response) => {
          if (response.success) {
            this.clientAccessTokens = response.data
          }
        })
    }
  }
}
</script>
